export * from './locales';

export { default as createTranslations } from './createTranslations';
